<template>
  <div>
  <v-layout :align-center="$vuetify.breakpoint.xsOnly" >
      <slot name="icon">
        <v-icon color="primary" class="custom-icon pr-1" style="margin-top:13px;">
            {{icon}}
        </v-icon>
      </slot>
      <h3 class="primary--text text-uppercase textoAjustado" style="margin-top:19px;"><slot></slot></h3>
    <v-spacer></v-spacer>
    <v-scale-transition>
      <v-btn
        v-if="botonBorrar"
        style="margin-bottom: 1px;"
        icon
        class="buttonOtrosCompradores"
        @click="$emit('borrar')"
      >
        <!-- @click="mostrarAvisoBorrar(i)" -->
        <v-icon medium color="primary">remove_circle_outline</v-icon>
      </v-btn> 
    </v-scale-transition>
  </v-layout>
  <v-divider class="dividerSubtitle primary"></v-divider>
  </div>
</template>

<script>
export default {
  name: 'o-medium-title-erase',
  props: {
    value: {
      type: Boolean
    },
    icon: {
      type: String,
      default: 'icon-user'
    },
    botonBorrar: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generic/titulos/OMediumTitleErase.vue